import * as OrderHistoryItem from './OrderHistoryItem';

export default OrderHistoryItem;
